import { render } from "./LoginComponent.vue?vue&type=template&id=5bb4533c"
import script from "@/components/LoginComponent/LoginComponent?vue&type=script&lang=js"
export * from "@/components/LoginComponent/LoginComponent?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=5bb4533c&lang=css"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__